import React from 'react'
import SarasTrans from '../../notifications/SarasTrans';

const SarasAMCStatus = (props) => {
    const { hide, labelValuePair, variant, url } = props;

    if (hide === "0") {
        if (variant === "status") {

        }

        if (variant === "mini") {
            if(!labelValuePair[0].value) return null;

            return (
                <div className='uiFlexBox uiAMCStatusMini'
                    style={{
                        gap: '0px'
                    }}
                >
                    <a href={url} rel="noopener noreferrer" target="_blank" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <span className='uiAMCStatusLabel' style={{
                        fontSize: '10px',
                        fontWeight: '600',
                        letterSpacing: '0.04em'
                    }}>
                        <SarasTrans value={"AMC"} />
                    </span>
                    <span className={`uiAMCStatus${labelValuePair[0].value > 0 ? "Active" : "Inactive"}`} style={{
                        fontSize: '10px',
                        fontWeight: '600',
                    }}>
                        {labelValuePair[0].value > 0 ? "Active" : "Inactive"}
                    </span>
                    </a>
                </div>
            )
        }

        return (
            <div className='uiFlexBox uiAMCStatus'
                style={{
                    gap: '0px'
                }}
            >
                <a href={url} rel="noopener noreferrer" target="_blank" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                {labelValuePair.map((item) => (
                    <div
                        key={item.label}
                        className={`uiAMCStatusItem uiAMCStatus${item.classKey}`}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '4px 5px',
                        }}>
                        <span style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em'
                        }}>
                            <SarasTrans value={item.label} />
                        </span>
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '700',
                        }}>
                            {item.value}
                        </span>
                    </div>
                ))}
                </a>
            </div>
        )
    }

    return null;
}

export default SarasAMCStatus
